<template>
  <a-modal v-model:visible="info.visible" :title="'批量修改商品' + info.title" width="539px">
    <div class="box">
      <a-radio-group v-model:value="info.radioValue">
        <a-radio value="add">
          <div class="radio-box">
            自定义：
            <div class="item" @click="changeValue('add')">
              <div class="inline">
                来源{{ info.title === '库存' ? '库存' : '价格' }} *
                <a-input-number v-model:value="info.ratio" placeholder="请输入倍数" :min="0" :precision="info.title === '价格' ? 2 : 0" />
              </div>
              &nbsp;+&nbsp;
              <a-input-number v-model:value="info.addNum" placeholder="请输入递增数" :min="0" :precision="info.title === '价格' ? 2 : 0" s/>
            </div>
          </div>
        </a-radio>
        <a-radio value="update">
          <div class="radio-box">
            固<i style="margin-left: 1em" />定：
            <div class="item" @click="changeValue('update')">
              <a-input-number v-model:value="info.value" placeholder="请输入数字" :min="0" :precision="info.title === '价格' ? 2 : 0" />
            </div>
          </div>
        </a-radio>
      </a-radio-group>
      <div v-if="info.title ==='库存'" class="item">
        来源SKU库存为 0 时，将SKU库存设置为：
        <a-input-number v-model:value="info.stock" placeholder="请输入数字" :min="0" :precision="0" />
      </div>
    </div>
    <template #footer>
      <a-button type="primary" @click="submit">确定修改</a-button>
      <a-button @click="info.visible = false">取消修改</a-button>
    </template>
  </a-modal>
</template>
<script>
export default {
  data() {
    return {
      info: {
        title: "价格", // 标题
        visible: false, // 是否显示弹出框
        radioValue: "add", // 选项
        ratio: null, // 百分比
        addNum: null, // 递增数
        value: null, // 固定值
        stock: null // 0库存修改
      }
    }
  },
  methods: {
    submit() {
      this.$emit('update', this.info)
    },
    changeValue(value) {
      this.info.radioValue = value
    }
  }
}
</script>
<style scoped lang="less">
	@import './index';
</style>